import Box from '@mui/material/Box'
import PageContainer from './layout/PageContainer'
import React from 'react'

const EmptyPageContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <PageContainer>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          //minHeight is set so that footer is always at the bottom of the page
          minHeight: 'calc(80vh - 280px)',
        }}
      >
        {children}
      </Box>
    </PageContainer>
  )
}

export default EmptyPageContainer
